import { type ReactNode } from "react";

export const getTabId = (index: number) => `tab-${index}`;

export const getTabPanelId = (index: number) => `tabpanel-${index}`;

/** Spread onto the `Tab` at `index` so it and its `TabPanel` name each other. */
export const tabProps = (index: number) => ({
  id: getTabId(index),
  "aria-controls": getTabPanelId(index),
});

/** `0` is a label a tab can carry, so only `null`, `undefined` and `""` count as none. */
export const isIconOnlyTab = (label: ReactNode, icon: ReactNode) =>
  (label === undefined || label === null || label === "") && Boolean(icon);
